/* eslint-disable indent */
import { createContext, /* useEffect */ useState } from "react";
// import { useLocation } from "react-router-dom";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
	// const navigate = useLocation();
	const [selectedLocation, setSelectedLocation] = useState(null);
	const [title, setTitle] = useState("");
	const [user, setUser] = useState(null);
	const [userLanguage, setUserLanguage] = useState("");

	const handleTitle = (title) => {
		setTitle(title);
	};

	const changeLanguage = (lang) => {
		setUserLanguage(lang);
	};

	return (
		<UserContext.Provider
			value={{
				title,
				handleTitle,
				selectedLocation,
				setSelectedLocation,
				user,
				setUser,
				changeLanguage,
				userLanguage
			}}
		>
			{children}
		</UserContext.Provider>
	);
};
